import React from 'react';

import { Modal, Header, Body, Footer, FooterButton } from './modalElements';
import { ModalContent } from './styles';

// A generic modal that can display some text and confirm or cancel
export default React.memo(
  ({
    title,
    confirmButtonText,
    onConfirm,
    onCancel,
    isOpen = true,
    loading = false,
    additionalActionButton = [],
    children,
  }) => {
    return (
      <Modal isOpen={isOpen}>
        {title && <Header>{title}</Header>}
        <Body loading={loading}>{children && <ModalContent>{children}</ModalContent>}</Body>
        <Footer>
          {additionalActionButton &&
            additionalActionButton.map(({ text, onClick }) => {
              return React.Children.toArray(<FooterButton label={text} onClick={onClick} />);
            })}
          {onCancel && <FooterButton label="Cancel" onClick={onCancel} />}
          <FooterButton label={confirmButtonText ?? 'Confirm'} onClick={onConfirm} />
        </Footer>
      </Modal>
    );
  }
);
